module.exports = __webpack_public_path__ + "static/img/ss.ee171740.svg";